import { ReactComponent as AlertIcon } from "./files/AlertIcon.svg";
import { ReactComponent as ArrowDownFilledIcon } from "./files/ArrowDownFilledIcon.svg";
import { ReactComponent as ArrowDownIcon } from "./files/ArrowDownIcon.svg";
import { ReactComponent as ArrowLeftIcon } from "./files/ArrowLeftIcon.svg";
import { ReactComponent as ArrowRightIcon } from "./files/ArrowRightIcon.svg";
import { ReactComponent as ArrowUpIcon } from "./files/ArrowUpIcon.svg";
import { ReactComponent as CheckboxAgreeIcon } from "./files/CheckboxAgreeIcon.svg";
import { ReactComponent as CloseIcon } from "./files/CloseIcon.svg";
import { ReactComponent as DonutIcon } from "./files/DonutIcon.svg";
import { ReactComponent as DownloadIcon } from "./files/DownloadIcon.svg";
import { ReactComponent as EyeIcon } from "./files/EyeIcon.svg";
import { ReactComponent as EyeOffIcon } from "./files/EyeOffIcon.svg";
import { ReactComponent as GlobalWorldIcon } from "./files/GlobalWorldIcon.svg";
import { ReactComponent as HamburgerMenuIcon } from "./files/HamburgerMenuIcon.svg";
import { ReactComponent as LinkedInIcon } from "./files/LinkedInIcon.svg";
import { ReactComponent as MinusIcon } from "./files/MinusIcon.svg";
import { ReactComponent as PlusIcon } from "./files/PlusIcon.svg";
import { ReactComponent as SendIcon } from "./files/SendIcon.svg";
import { ReactComponent as CheckboxMarkIcon } from "./files/CheckboxMarkIcon.svg";
import { ReactComponent as GoogleLogoIcon } from "./files/GoogleLogoIcon.svg";
import { ReactComponent as FacebookLogoIcon } from "./files/FacebookLogoIcon.svg";
import { ReactComponent as AnimalsCardsIcon } from "./files/AnimalsCardsIcon.svg";
import { ReactComponent as DashboardIcon } from "./files/DashboardIcon.svg";
import { ReactComponent as EmployeesIcon } from "./files/EmployeesIcon.svg";
import { ReactComponent as MessagesIcon } from "./files/MessagesIcon.svg";
import { ReactComponent as VoluntaryIcon } from "./files/VoluntaryIcon.svg";
import { ReactComponent as BellIcon } from "./files/BellIcon.svg";
import { ReactComponent as IdentificationIcon } from "./files/IdentificationIcon.svg";
import { ReactComponent as CalendarIcon } from "./files/CalendarIcon.svg";
import { ReactComponent as RadioMarkIcon } from "./files/RadioMarkIcon.svg";
import { ReactComponent as SendMessageIcon } from "./files/SendMessageIcon.svg";
import { ReactComponent as MoreIcon } from "./files/MoreIcon.svg";
import { ReactComponent as CheckIcon } from "./files/CheckIcon.svg";
import { ReactComponent as UserRemoveIcon } from "./files/UserRemoveIcon.svg";
import { ReactComponent as SearchCircleIcon } from "./files/SearchCircleIcon.svg";
import { ReactComponent as UserCircleIcon } from "./files/UserCircleIcon.svg";
import { ReactComponent as HeartGreenIcon } from "./files/HeartGreenIcon.svg";
import { styled } from "styled-components";

export {
  AlertIcon,
  ArrowDownFilledIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  CheckboxAgreeIcon,
  CloseIcon,
  DonutIcon,
  DownloadIcon,
  EyeIcon,
  EyeOffIcon,
  GlobalWorldIcon,
  HamburgerMenuIcon,
  LinkedInIcon,
  MinusIcon,
  PlusIcon,
  SendIcon,
  CheckboxMarkIcon,
  GoogleLogoIcon,
  FacebookLogoIcon,
  AnimalsCardsIcon,
  DashboardIcon,
  EmployeesIcon,
  MessagesIcon,
  VoluntaryIcon,
  BellIcon,
  IdentificationIcon,
  CalendarIcon,
  RadioMarkIcon,
  SendMessageIcon,
  MoreIcon,
  CheckIcon,
  UserRemoveIcon,
  SearchCircleIcon,
  UserCircleIcon,
  HeartGreenIcon,
};

export const StyledPlusIcon = styled(PlusIcon)`
  height: 20px;
  width: 20px;
`;
